<script setup lang="ts">
const { currentPath } = useNavigation()
const { navPathViewTestId } = useTestId()
const { state: gestureState } = useGestures()
const { navPathId } = useGlobals()

// @ts-expect-error -- we use core js to polyfill toReversed (see polyfill.ts)
const reversePath = computed(() => currentPath.value?.toReversed() ?? [])
</script>

<template>
  <nav-pill
    v-if="reversePath.length"
    :id="navPathId"
    class="path-pill-container"
    :data-testid="navPathViewTestId"
  >
    <template v-for="(file, i) in reversePath" :key="file.fileId">
      <nav-pill-button
        :data-path-file-id="file.fileId"
        class="path-pill-button"
        :selected="gestureState.pathFileDraggedOver?.fileId === file.fileId"
        :class="{
          bare: i !== 0,
          focused: i === reversePath.length - 1,
          default: i !== reversePath.length - 1,
        }"
      >
        <file-item
          :file
          class="file-item"

          :hide-thumbnail="i !== 0"
        />
      </nav-pill-button>
      <div v-if="i !== reversePath.length - 1" class="separator-container">
        <div class="separator" />
      </div>
    </template>
  </nav-pill>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.path-pill-container
  @apply overflow-hidden p-[#{$pill-m-button}]

.path-pill-button
  @apply flex-none pr-1.5 pl-0.5
  &.bare
    @apply pl-1.5
  &.focused
    @apply text-[#{$pill-path-t-focused}]
  &.default
    @apply text-[#{$pill-path-t-default}]

.file-item
  @apply max-w-40 h-full gap-[#{$pill-gap-default}]

.separator-container
  @apply pill-item h-full flex-none px-0.5 pointer-events-none
.separator
  @apply border-l-[#{$pill-path-b-separator}] h-full w-0 flex-none rotate-22 transform border-l
</style>
